import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'container py-[24px] lg:pt-[32px] lg:pb-[52px]',
    breadcrumbs: 'pb-[24px]',
    grid: 'flex flex-wrap gap-[20px]',
    banner: '',
    bannerContainer: 'max-h-[500px] lg:max-h-[400px]',
    articleItem: 'w-full max-w-[453px]',
    articleItemContainer: 'max-h-[351px] lg:max-h-none',
    sortBlock: 'justify-start py-[24px]',
    buttonWrapper:
      'flex items-center justify-center pt-[24px] lg:pt-[48px] lg:pb-[48px]'
  }
});
